import axiosConfig from '../axiosConfig';

export default {
	/*
        GET     /api/v1/search/countries
    */
	getCountries() {
		return axiosConfig.get('/search/countries');
	},

	/*
        GET     /api/v1/search/regions/{country_id}
    */
	getRegions(countryId) {
		return axiosConfig.get('/search/regions/' + countryId);
	},

	/*
        GET     /api/v1/search/bricks/countries/{country}/regions/{region}
    */
	getBricks(countryId, regionId) {
		return axiosConfig.get('/search/bricks/countries/' + countryId + '/regions/' + regionId);
	},

	/*
        GET     /api/v1/search/atc_codes/{atc_code}
    */
	getAtcCodes(atcCode) {
		return axiosConfig.get('/search/atc_codes/' + atcCode);
	},

	/*
        GET     /api/v1/search/substances/{substance}
    */
	getSubstances(substance) {
		return axiosConfig.get('/search/substances/' + substance);
	},

	/*
        GET     /api/v1/search/products/{product}
    */
	getProducts(product) {
		return axiosConfig.get('/search/products/' + product);
	},

	/*
        GET     /api/v1/search/vnrs/{vnr}
    */
	getVnrs(vnr) {
		return axiosConfig.get('/search/vnrs/' + vnr);
	},

	/*
        GET     /api/v1/search/companies/{company}
    */
	getCompanies(company) {
		return axiosConfig.get('/search/companies/' + company);
	},

	/*
        GET     /api/v1/search/get_company/{companyId}
    */
	getCompanyById(companyId) {
		return axiosConfig.get('/search/get_company/' + companyId);
	},
};
